import styled from "styled-components";
import { Button } from "antd";

export const ContainerSC = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
`;

export const TimeInputContainerSC = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    
    & > span {
        font-weight: 600;
        min-width: 50px;
    }
`;

export const TimeInputGroupSC = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    
    input {
        width: 60px;
        padding: 5px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
    }
`;

export const SubtitleListSC = styled.div`
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    padding: 10px;
    background: #fafafa;
`;

export const SubtitleItemSC = styled.div`
    padding: 5px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 12px;
    
    &:last-child {
        border-bottom: none;
    }
    
    .time {
        font-weight: 600;
        margin-right: 10px;
        color: #1890ff;
    }
`;

export const WarningTextSC = styled.div`
    color: #ff4d4f;
    font-size: 13px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const StyledButton = styled(Button)`
    &.ant-btn-primary {
        background-color: #1890ff;
    }
    &.ant-btn-danger {
        background-color: #ff4d4f;
        border-color: #ff4d4f;
        color: white;
    }
`;

export const PickButtonSC = styled.div<{ $active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid ${({ $active }) => ($active ? "#1890ff" : "#d9d9d9")};
    background: ${({ $active }) => ($active ? "#e6f7ff" : "#fff")};
    color: ${({ $active }) => ($active ? "#1890ff" : "#666")};
    transition: all 0.2s;

    &:hover {
        border-color: #1890ff;
        color: #1890ff;
    }

    div {
        font-size: 18px;
    }
`;
